import { render } from "./OrganizationProfilePage.vue?vue&type=template&id=a133bd10&scoped=true"
import script from "./OrganizationProfilePage.vue?vue&type=script&lang=js"
export * from "./OrganizationProfilePage.vue?vue&type=script&lang=js"

import "./OrganizationProfilePage.vue?vue&type=style&index=0&id=a133bd10&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a133bd10"]])

export default __exports__